import { useMutation, UseMutationConfig } from '@libs/use';
import { CreatePreInitialPublicOffer } from '@libs/api-reference';

import * as API from '../requests';

function preOfferFactory(data: CreatePreInitialPublicOffer) {
  return {
    ...data,
    orderExecutionType: 'Desktop-Helium-PreIPO',
  };
}

type UseCreatePreInitialPublicOfferQueryType = {
  onSuccess?: UseMutationConfig<any>['onSuccess'];
  onReject?: UseMutationConfig<any>['onReject'];
};

export default function useCreatePreInitialPublicOfferQuery({
  onReject,
  onSuccess,
}: UseCreatePreInitialPublicOfferQueryType) {
  const { execute: createPreInitialPublicOffer, ...query } = useMutation(
    (data: CreatePreInitialPublicOffer) =>
      API.createPreInitialPublicOffer(preOfferFactory(data)),
    {
      onSuccess,
      onReject,
    }
  );

  return { createPreInitialPublicOffer, ...query };
}
